import { NgModule } from '@angular/core';
import { PlusMinPricePipe } from './plus-min-price.pipe';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [PlusMinPricePipe],
  imports: [CommonModule],
  exports: [PlusMinPricePipe],
})
export class PlusMinPricePipeModule {}
